"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_link_1 = require("@hotelplan/components.common.link");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const PhoneTitle = styled_components_1.default.p.attrs({
    'data-id': `mobile-nav-phone-title`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    color: 'secondary',
    fontSize: 1,
}));
const PhoneWrapper = styled_components_1.default.div({
    marginTop: '15px',
});
const PhoneNumberLinkWrap = (0, styled_components_1.default)(components_common_link_1.Link).attrs({
    testId: 'mobile-nav-phone-link',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    color: 'primary',
    fontSize: 3,
    letterSpacing: '0.8px',
}));
const PhoneNumberLink = ({ phoneTitle, phoneNumber, onNumberClick, className, }) => {
    return (react_1.default.createElement(PhoneWrapper, { className: className },
        phoneTitle && (react_1.default.createElement(PhoneTitle, { className: "phone-title" }, phoneTitle + ':')),
        phoneNumber && (react_1.default.createElement(PhoneNumberLinkWrap, { className: "phone-number", href: `tel:${phoneNumber}`, onClick: onNumberClick },
            react_1.default.createElement("span", null, phoneNumber)))));
};
exports.default = PhoneNumberLink;
//# sourceMappingURL=PhoneNumberLink.js.map